<template>
    <div class="container-fluid">
        <h4 class="bg-secondary text-white text-center p-2">Subnetting Redes Asimétricas (VLSM)</h4>
        <div class="form-group">
            <label>Dirección Red:</label>
            <input type="text" class="form-control" v-model="netaddress">
        </div>
        <div class="form-group">
            <label>Máscara (CIDR):</label>
            <input type="text" class="form-control" v-model="netmaskcidr">
        </div>
        <div class="row">
            <div class="col">Segmentos</div>
        </div>
        <div class="form-row">
            <div class="col">
                <label>Número de segmentos:</label>
                <input type="text" class="form-control" v-model="numsegments">
            </div>
        </div>
        <div class="container" v-for="(segment, index) in segments" :key="index">
            <div class="form-row">
                <div class="col">
                    <label>Nombre Segmento #{{ index }}:</label>
                    <input type="text" class="form-control" v-model="segments[index].name">
                </div>
                <div class="col">
                    <label>Tamaño:</label>
                    <input type="text" class="form-control" v-model="segments[index].hosts">
                </div>
            </div>
        </div>
        <asimmetrical-subnetting :initialnetaddress=netaddress :initialnetmaskcidr=netmaskcidr :segments=segments></asimmetrical-subnetting>
    </div>
</template>

<script>

import AsimmetricalSubnetting from "./AsimmetricalSubnetting";

export default {
    data: function () {
        return {
            netaddress: '',
            netmaskcidr: 0,
            numsegments: 1,
            segments: [{
                name: 'Segmento1',
                hosts: 2
            }],
        }
    },
    watch: {
        numsegments: function(newval, oldval) {
            if (newval > oldval) {
                for (let i = 0; i < (newval - oldval); i++) {
                    this.segments.push({name: 'Segmento' + (parseInt(oldval) + i + 1), hosts: 2});
                }
            } else {
                if (newval < oldval) {
                    for (let i = 0; i < (oldval - newval); i++) {
                        this.segments.pop();
                    }
                }
            }
        }
    },
    components: {'asimmetrical-subnetting': AsimmetricalSubnetting }
}
</script>